export const CloseIcon = ({ height, width, color }) => (
  <svg
    height={height || "52"}
    fill={color || "currentColor"}
    width={width || "52"}
    x="0"
    y="0"
    viewBox="0 0 311 311.07733"
  >
    <g>
      <path
        d="m16.035156 311.078125c-4.097656 0-8.195312-1.558594-11.308594-4.695313-6.25-6.25-6.25-16.382812 0-22.632812l279.0625-279.0625c6.25-6.25 16.382813-6.25 22.632813 0s6.25 16.382812 0 22.636719l-279.058594 279.058593c-3.136719 3.117188-7.234375 4.695313-11.328125 4.695313zm0 0"
        fill={"currentColor"}
        data-original="#000000"
      />
      <path
        d="m295.117188 311.078125c-4.097657 0-8.191407-1.558594-11.308594-4.695313l-279.082032-279.058593c-6.25-6.253907-6.25-16.386719 0-22.636719s16.382813-6.25 22.636719 0l279.058594 279.0625c6.25 6.25 6.25 16.382812 0 22.632812-3.136719 3.117188-7.230469 4.695313-11.304687 4.695313zm0 0"
        fill={color || "currentColor"}
        data-original="#000000"
      />
    </g>
  </svg>
);
export const SearchIcon = ({ height, width, color }) => (
  <svg
    height={height || "52"}
    fill={color || "none"}
    width={width || "52"}
    viewBox="0 0 13 13"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.8067 10.86L9.54 8.6C10.2713 7.66831 10.6681 6.51777 10.6667 5.33334C10.6667 4.2785 10.3539 3.24736 9.76784 2.37029C9.18181 1.49323 8.34885 0.809646 7.37431 0.405978C6.39978 0.00231083 5.32742 -0.103307 4.29285 0.102481C3.25829 0.308269 2.30798 0.81622 1.5621 1.5621C0.81622 2.30798 0.308269 3.25829 0.102481 4.29285C-0.103307 5.32742 0.00231083 6.39978 0.405978 7.37431C0.809646 8.34885 1.49323 9.18181 2.37029 9.76784C3.24736 10.3539 4.2785 10.6667 5.33334 10.6667C6.51777 10.6681 7.66831 10.2713 8.6 9.54L10.86 11.8067C10.922 11.8692 10.9957 11.9188 11.077 11.9526C11.1582 11.9864 11.2453 12.0039 11.3333 12.0039C11.4213 12.0039 11.5085 11.9864 11.5897 11.9526C11.671 11.9188 11.7447 11.8692 11.8067 11.8067C11.8692 11.7447 11.9188 11.671 11.9526 11.5897C11.9864 11.5085 12.0039 11.4213 12.0039 11.3333C12.0039 11.2453 11.9864 11.1582 11.9526 11.077C11.9188 10.9957 11.8692 10.922 11.8067 10.86ZM1.33334 5.33334C1.33334 4.54221 1.56793 3.76885 2.00746 3.11106C2.44698 2.45326 3.0717 1.94057 3.8026 1.63782C4.53351 1.33507 5.33777 1.25585 6.1137 1.41019C6.88962 1.56454 7.60235 1.9455 8.16176 2.50491C8.72117 3.06432 9.10214 3.77705 9.25648 4.55297C9.41082 5.3289 9.3316 6.13317 9.02885 6.86407C8.7261 7.59497 8.21341 8.21969 7.55562 8.65921C6.89782 9.09874 6.12446 9.33334 5.33334 9.33334C4.27247 9.33334 3.25505 8.91191 2.50491 8.16176C1.75476 7.41162 1.33334 6.3942 1.33334 5.33334Z"
      fill="#818181"
    />
  </svg>
);

export const BalanceIcon = ({ height, width, color }) => (
  <svg
    width={width || "14"}
    height={height || "15"}
    viewBox="0 0 14 15"
    fill={color || "none"}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.47368 7.40689V10.2995C1.47368 10.8997 1.96737 11.3842 2.57895 11.3842C3.19053 11.3842 3.68421 10.8997 3.68421 10.2995V7.40689C3.68421 6.80668 3.19053 6.32216 2.57895 6.32216C1.96737 6.32216 1.47368 6.80668 1.47368 7.40689ZM5.89474 7.40689V10.2995C5.89474 10.8997 6.38842 11.3842 7 11.3842C7.61158 11.3842 8.10526 10.8997 8.10526 10.2995V7.40689C8.10526 6.80668 7.61158 6.32216 7 6.32216C6.38842 6.32216 5.89474 6.80668 5.89474 7.40689ZM1.10526 15H12.8947C13.5063 15 14 14.5155 14 13.9153C14 13.3151 13.5063 12.8305 12.8947 12.8305H1.10526C0.493684 12.8305 0 13.3151 0 13.9153C0 14.5155 0.493684 15 1.10526 15ZM10.3158 7.40689V10.2995C10.3158 10.8997 10.8095 11.3842 11.4211 11.3842C12.0326 11.3842 12.5263 10.8997 12.5263 10.2995V7.40689C12.5263 6.80668 12.0326 6.32216 11.4211 6.32216C10.8095 6.32216 10.3158 6.80668 10.3158 7.40689ZM6.31474 0.168133L0.493684 3.17645C0.191579 3.32831 0 3.63927 0 3.97192C0 4.47089 0.412632 4.87586 0.921053 4.87586H13.0863C13.5874 4.87586 14 4.47089 14 3.97192C14 3.63927 13.8084 3.32831 13.5063 3.17645L7.68526 0.168133C7.25789 -0.0560444 6.7421 -0.0560444 6.31474 0.168133V0.168133Z"
      fill={color || "currentColor"}
    />
  </svg>
);
export const ProfileIcon = ({ height, width, color }) => (
  <svg
    width={width || "35"}
    height={height || "22"}
    viewBox="0 0 35 22"
    fill={color || "none"}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.2317 8.61442C13.6216 8.61442 15.5591 6.71487 15.5591 4.37166C15.5591 2.02845 13.6216 0.128906 11.2317 0.128906C8.84174 0.128906 6.9043 2.02845 6.9043 4.37166C6.9043 6.71487 8.84174 8.61442 11.2317 8.61442Z"
      fill={color || "#9E9E9E"}
    />
    <path
      d="M21.9492 18.4294C21.5003 16.4256 20.471 14.5915 18.9849 13.1472C18.6242 12.7923 18.2334 12.4682 17.8165 12.1784C15.9183 10.7824 13.6046 10.037 11.2318 10.057C8.33041 10.0425 5.54085 11.1533 3.47143 13.1472C1.98536 14.5915 0.956085 16.4256 0.50721 18.4294C0.429189 18.7837 0.433404 19.1507 0.519542 19.5032C0.605681 19.8557 0.77154 20.1847 1.00485 20.4659C1.24648 20.7532 1.55075 20.9836 1.89525 21.1402C2.23976 21.2969 2.61571 21.3758 2.99543 21.371H19.4681C19.849 21.3713 20.225 21.2875 20.5683 21.1259C20.9116 20.9644 21.2135 20.7291 21.4515 20.4376C21.6806 20.1597 21.8441 19.8355 21.9301 19.4883C22.0162 19.141 22.0227 18.7794 21.9492 18.4294Z"
      fill={color || "#9E9E9E"}
    />
  </svg>
);

export const LogoutIcon = ({ height, width, color }) => (
  <svg
    width={width || "35"}
    height={height || "30"}
    viewBox="0 0 25 18"
    fill={color || "none"}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.75 1.5H5.25C3.975 1.5 3 2.475 3 3.75V8.25H9.45L7.725 6.525C7.425 6.225 7.425 5.775 7.725 5.475C8.025 5.175 8.475 5.175 8.775 5.475L11.775 8.475C12.075 8.775 12.075 9.225 11.775 9.525L8.775 12.525C8.475 12.825 8.025 12.825 7.725 12.525C7.425 12.225 7.425 11.775 7.725 11.475L9.45 9.75H3V14.25C3 15.525 3.975 16.5 5.25 16.5H12.75C14.025 16.5 15 15.525 15 14.25V3.75C15 2.475 14.025 1.5 12.75 1.5Z"
      fill={color || "none"}
    />
  </svg>
);

export const NotificationIcon = ({ height, width, color }) => (
  <svg
    width={width || "18"}
    height={height || "22"}
    viewBox="0 0 18 22"
    fill={color || "none"}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18 16.8987V17.9691C18 18.0936 17.9501 18.213 17.8613 18.3011C17.7724 18.3891 17.6519 18.4386 17.5263 18.4386H0.473685C0.348056 18.4386 0.227572 18.3891 0.138739 18.3011C0.0499063 18.213 3.79224e-07 18.0936 3.79224e-07 17.9691V16.8987C-0.000260704 16.5538 0.134297 16.2223 0.375422 15.9737C0.616546 15.7251 0.94548 15.5787 1.29316 15.5654C1.36039 15.4447 1.40379 15.3125 1.42105 15.1757V9.57481C1.41829 8.47066 1.67039 7.3805 2.15807 6.38776C2.64575 5.39502 3.35609 4.52599 4.23474 3.84718C5.12582 3.15856 6.16411 2.68123 7.27007 2.45175C8.37603 2.22227 9.52031 2.24672 10.6153 2.52325C13.6421 3.25563 16.1053 6.44809 16.1053 9.63584V15.0536C16.2478 15.2659 16.4394 15.4413 16.6642 15.5654C17.0194 15.5678 17.3591 15.7094 17.6093 15.9592C17.8596 16.209 18 16.5467 18 16.8987ZM8.77263 1.82842C9.32678 1.83246 9.87908 1.89223 10.4211 2.00682V1.53734C10.4211 1.1638 10.2713 0.80556 10.0048 0.541427C9.73834 0.277295 9.37689 0.128906 9 0.128906C8.62311 0.128906 8.26166 0.277295 7.99516 0.541427C7.72866 0.80556 7.57895 1.1638 7.57895 1.53734V1.92231C7.97392 1.86156 8.37293 1.83017 8.77263 1.82842ZM5.72211 18.908C5.84162 19.6848 6.23798 20.3934 6.83933 20.9054C7.44068 21.4174 8.20722 21.699 9 21.699C9.79278 21.699 10.5593 21.4174 11.1607 20.9054C11.762 20.3934 12.1584 19.6848 12.2779 18.908H5.72211Z"
      fill={color || "#9E9E9E"}
    />
  </svg>
);
export const TransactionIcon = ({ height, width, color }) => (
  <svg
    width={width || "14"}
    height={height || "15"}
    viewBox="0 0 14 14"
    fill={color || "none"}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.5 0H1.5C1.10218 0 0.720645 0.158036 0.43934 0.43934C0.158036 0.720645 0 1.10218 0 1.5V12.5C0 12.8978 0.158036 13.2794 0.43934 13.5607C0.720645 13.842 1.10218 14 1.5 14H12.5C12.8978 14 13.2794 13.842 13.5607 13.5607C13.842 13.2794 14 12.8978 14 12.5V1.5C14 1.10218 13.842 0.720645 13.5607 0.43934C13.2794 0.158036 12.8978 0 12.5 0ZM3 3.5C3 3.36739 3.05268 3.24022 3.14645 3.14645C3.24022 3.05268 3.36739 3 3.5 3H7.5C7.63261 3 7.75979 3.05268 7.85355 3.14645C7.94732 3.24022 8 3.36739 8 3.5V4.53086C8 4.66347 7.94732 4.79065 7.85355 4.88442C7.75979 4.97819 7.63261 5.03086 7.5 5.03086H3.5C3.36739 5.03086 3.24022 4.97819 3.14645 4.88442C3.05268 4.79065 3 4.66347 3 4.53086V3.5ZM6 10.5C6 10.6326 5.94732 10.7598 5.85355 10.8536C5.75979 10.9473 5.63261 11 5.5 11H3.5C3.36739 11 3.24022 10.9473 3.14645 10.8536C3.05268 10.7598 3 10.6326 3 10.5V9.5C3 9.36739 3.05268 9.24021 3.14645 9.14645C3.24022 9.05268 3.36739 9 3.5 9H5.5C5.63261 9 5.75979 9.05268 5.85355 9.14645C5.94732 9.24021 6 9.36739 6 9.5V10.5ZM11 7.5C11 7.63261 10.9473 7.75979 10.8536 7.85355C10.7598 7.94732 10.6326 8 10.5 8H3.5C3.36739 8 3.24022 7.94732 3.14645 7.85355C3.05268 7.75979 3 7.63261 3 7.5V6.5C3 6.36739 3.05268 6.24021 3.14645 6.14645C3.24022 6.05268 3.36739 6 3.5 6H10.5C10.6326 6 10.7598 6.05268 10.8536 6.14645C10.9473 6.24021 11 6.36739 11 6.5V7.5Z"
      fill={color || "currentColor"}
    />
  </svg>
);
export const SettingsIcon = ({ height, width, color }) => (
  <svg
    width={width || "14"}
    height={height || "15"}
    viewBox="0 0 18 18"
    fill={color || "none"}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.2416 7.59935L16.5832 5.49935C16.5122 5.25665 16.3929 5.03074 16.2326 4.83512C16.0724 4.63949 15.8743 4.47815 15.6504 4.36072C15.4264 4.24328 15.181 4.17216 14.929 4.1516C14.6769 4.13103 14.4233 4.16144 14.1832 4.24102L13.8999 4.33268C13.6779 4.40605 13.4415 4.42467 13.2108 4.38694C12.9801 4.34922 12.7619 4.25627 12.5749 4.11602L12.4832 4.04935C12.3007 3.90966 12.1536 3.72904 12.0537 3.52204C11.9538 3.31505 11.904 3.08748 11.9082 2.85768V2.62435C11.9123 2.10104 11.7085 1.59751 11.3416 1.22435C11.1671 1.04806 10.9594 0.907984 10.7306 0.812168C10.5018 0.716352 10.2563 0.666684 10.0082 0.666016H7.88324C7.37339 0.672604 6.88678 0.880342 6.52936 1.244C6.17195 1.60766 5.97267 2.09779 5.97491 2.60768V2.80768C5.97411 3.04958 5.91903 3.28821 5.81375 3.50599C5.70847 3.72377 5.55565 3.91514 5.36657 4.06602L5.25824 4.14935C5.04936 4.30737 4.80505 4.41198 4.54654 4.4541C4.28803 4.49621 4.02314 4.47456 3.77491 4.39102C3.54692 4.31212 3.30529 4.2803 3.06466 4.29749C2.82402 4.31468 2.58937 4.38052 2.37491 4.49102C2.15162 4.60184 1.95353 4.75743 1.79296 4.9481C1.63239 5.13878 1.51278 5.36046 1.44157 5.59935L0.75824 7.76602C0.599775 8.25451 0.640414 8.7858 0.871331 9.24452C1.10225 9.70323 1.5048 10.0523 1.99157 10.216H2.12491C2.34946 10.3002 2.551 10.4361 2.71316 10.6127C2.87533 10.7894 2.99356 11.0018 3.05824 11.2327L3.10824 11.366C3.20114 11.6211 3.2322 11.8946 3.19888 12.1641C3.16557 12.4335 3.06881 12.6912 2.91657 12.916C2.60842 13.3357 2.47844 13.86 2.55491 14.375C2.63138 14.89 2.90811 15.354 3.32491 15.666L5.04991 16.9743C5.37653 17.2118 5.7711 17.3375 6.17491 17.3327C6.28298 17.3433 6.39183 17.3433 6.49991 17.3327C6.74999 17.2843 6.98759 17.1854 7.19821 17.0421C7.40882 16.8989 7.58803 16.7142 7.72491 16.4993L7.91657 16.2243C8.05102 16.0315 8.22892 15.8729 8.43592 15.7615C8.64292 15.65 8.87322 15.5888 9.10824 15.5827C9.35454 15.5766 9.59836 15.6331 9.81694 15.7467C10.0355 15.8604 10.2218 16.0276 10.3582 16.2327L10.4582 16.3743C10.6003 16.5858 10.7842 16.7659 10.9985 16.9037C11.2128 17.0414 11.4531 17.1338 11.7044 17.1751C11.9558 17.2165 12.213 17.206 12.4602 17.1442C12.7073 17.0825 12.9392 16.9708 13.1416 16.816L14.8332 15.5493C15.2332 15.2387 15.4992 14.7868 15.5767 14.2864C15.6542 13.7859 15.5372 13.2747 15.2499 12.8577L15.0332 12.541C14.903 12.3397 14.8176 12.1126 14.7831 11.8754C14.7486 11.6381 14.7657 11.3961 14.8332 11.166C14.9021 10.9197 15.0299 10.6939 15.2056 10.508C15.3812 10.3222 15.5995 10.1819 15.8416 10.0993L16.0082 10.041C16.4905 9.87367 16.8888 9.52537 17.1189 9.06973C17.3491 8.61409 17.3931 8.08682 17.2416 7.59935ZM8.99991 11.916C8.42305 11.916 7.85914 11.745 7.37949 11.4245C6.89985 11.104 6.52601 10.6485 6.30526 10.1155C6.0845 9.58256 6.02674 8.99611 6.13928 8.43034C6.25182 7.86456 6.52961 7.34486 6.93751 6.93695C7.34542 6.52905 7.86512 6.25127 8.43089 6.13873C8.99667 6.02619 9.58312 6.08394 10.1161 6.3047C10.649 6.52546 11.1045 6.89929 11.425 7.37894C11.7455 7.85858 11.9166 8.42249 11.9166 8.99935C11.9166 9.7729 11.6093 10.5148 11.0623 11.0617C10.5153 11.6087 9.77346 11.916 8.99991 11.916Z"
      fill={color || "currentColor"}
    />
  </svg>
);
export const WalletsIcon = ({ height, width, color }) => (
  <svg
    width={width || "14"}
    height={height || "15"}
    viewBox="0 0 14 13"
    fill={color || "none"}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.54583 7.63333C9.84097 7.63333 10.1036 7.51823 10.3339 7.28802C10.5641 7.05781 10.6792 6.78924 10.6792 6.48229C10.6792 6.18715 10.5641 5.92743 10.3339 5.70312C10.1036 5.47882 9.84097 5.36667 9.54583 5.36667C9.25069 5.36667 8.98802 5.47882 8.75781 5.70312C8.5276 5.92743 8.4125 6.18715 8.4125 6.48229C8.4125 6.78924 8.5276 7.05781 8.75781 7.28802C8.98802 7.51823 9.25069 7.63333 9.54583 7.63333ZM7.52708 9.81146C7.12569 9.81146 6.80694 9.6934 6.57083 9.45729C6.33472 9.22118 6.21667 8.90833 6.21667 8.51875V4.49896C6.21667 4.09757 6.33472 3.78177 6.57083 3.55156C6.80694 3.32135 7.12569 3.20625 7.52708 3.20625H12.2906C12.692 3.20625 13.0108 3.32135 13.2469 3.55156C13.483 3.78177 13.601 4.09757 13.601 4.49896V8.51875C13.601 8.90833 13.483 9.22118 13.2469 9.45729C13.0108 9.6934 12.692 9.81146 12.2906 9.81146H7.52708ZM1.1875 12.875C0.915972 12.875 0.671007 12.7687 0.452604 12.5562C0.234201 12.3437 0.125 12.0958 0.125 11.8125V1.1875C0.125 0.915972 0.234201 0.671007 0.452604 0.452604C0.671007 0.234201 0.915972 0.125 1.1875 0.125H11.8125C12.0958 0.125 12.3437 0.234201 12.5562 0.452604C12.7687 0.671007 12.875 0.915972 12.875 1.1875V2.14375H7.52708C6.84236 2.14375 6.27569 2.36806 5.82708 2.81667C5.37847 3.26528 5.15417 3.82604 5.15417 4.49896V8.51875C5.15417 9.19167 5.37847 9.75243 5.82708 10.201C6.27569 10.6497 6.84236 10.874 7.52708 10.874H12.875V11.8125C12.875 12.0958 12.7687 12.3437 12.5562 12.5562C12.3437 12.7687 12.0958 12.875 11.8125 12.875H1.1875Z"
      fill={color || "currentColor"}
    />
  </svg>
);
export const DashboardIcon = ({ height, width, color }) => (
  <svg
    width={width || "14"}
    height={height || "15"}
    viewBox="0 0 16 16"
    fill={color || "none"}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.895508 8.80553H7.21091V0.904297H0.895508V8.80553ZM0.895508 15.1265H7.21091V10.3858H0.895508V15.1265ZM8.78976 15.1265H15.1052V7.22528H8.78976V15.1265ZM8.78976 0.904297V5.64504H15.1052V0.904297H8.78976Z"
      fill={color || "currentColor"}
    />
  </svg>
);

export const PasswordEyeIcon = ({ height, width, color }) => (
  <svg
    height={height || "52"}
    fill={color || "#778699"}
    width={width || "52"}
    x="0"
    y="0"
    viewBox="0 0 511.999 511.999"
  >
    <g>
      <g>
        <g>
          <path
            d="M508.745,246.041c-4.574-6.257-113.557-153.206-252.748-153.206S7.818,239.784,3.249,246.035    c-4.332,5.936-4.332,13.987,0,19.923c4.569,6.257,113.557,153.206,252.748,153.206s248.174-146.95,252.748-153.201    C513.083,260.028,513.083,251.971,508.745,246.041z M255.997,385.406c-102.529,0-191.33-97.533-217.617-129.418    c26.253-31.913,114.868-129.395,217.617-129.395c102.524,0,191.319,97.516,217.617,129.418    C447.361,287.923,358.746,385.406,255.997,385.406z"
            fill={color || "#778699"}
            data-original="#000000"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M255.997,154.725c-55.842,0-101.275,45.433-101.275,101.275s45.433,101.275,101.275,101.275    s101.275-45.433,101.275-101.275S311.839,154.725,255.997,154.725z M255.997,323.516c-37.23,0-67.516-30.287-67.516-67.516    s30.287-67.516,67.516-67.516s67.516,30.287,67.516,67.516S293.227,323.516,255.997,323.516z"
            fill={color || "#778699"}
            data-original="#000000"
          />
        </g>
      </g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
    </g>
  </svg>
);

export const HiddenVisibilityIcon = ({ height, width, color }) => (
  <svg
    height={height || "52"}
    fill={color || "#778699"}
    width={width || "52"}
    x="0"
    y="0"
    viewBox="0 0 512.001 512.001"
  >
    <g>
      <g>
        <g>
          <path
            d="M316.332,195.662c-4.16-4.16-10.923-4.16-15.083,0c-4.16,4.16-4.16,10.944,0,15.083    c12.075,12.075,18.752,28.139,18.752,45.248c0,35.285-28.715,64-64,64c-17.109,0-33.173-6.656-45.248-18.752    c-4.16-4.16-10.923-4.16-15.083,0c-4.16,4.139-4.16,10.923,0,15.083c16.085,16.128,37.525,25.003,60.331,25.003    c47.061,0,85.333-38.272,85.333-85.333C341.334,233.187,332.46,211.747,316.332,195.662z"
            fill={color || "#778699"}
            data-original="#000000"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M270.87,172.131c-4.843-0.853-9.792-1.472-14.869-1.472c-47.061,0-85.333,38.272-85.333,85.333    c0,5.077,0.619,10.027,1.493,14.869c0.917,5.163,5.419,8.811,10.475,8.811c0.619,0,1.237-0.043,1.877-0.171    c5.781-1.024,9.664-6.571,8.64-12.352c-0.661-3.627-1.152-7.317-1.152-11.157c0-35.285,28.715-64,64-64    c3.84,0,7.531,0.491,11.157,1.131c5.675,1.152,11.328-2.859,12.352-8.64C280.534,178.702,276.652,173.155,270.87,172.131z"
            fill={color || "#778699"}
            data-original="#000000"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M509.462,249.102c-2.411-2.859-60.117-70.208-139.712-111.445c-5.163-2.709-11.669-0.661-14.379,4.587    c-2.709,5.227-0.661,11.669,4.587,14.379c61.312,31.744,110.293,81.28,127.04,99.371c-25.429,27.541-125.504,128-230.997,128    c-35.797,0-71.872-8.64-107.264-25.707c-5.248-2.581-11.669-0.341-14.229,4.971c-2.581,5.291-0.341,11.669,4.971,14.229    c38.293,18.496,77.504,27.84,116.523,27.84c131.435,0,248.555-136.619,253.483-142.443    C512.854,258.915,512.833,253.091,509.462,249.102z"
            fill={color || "#778699"}
            data-original="#000000"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M325.996,118.947c-24.277-8.171-47.829-12.288-69.995-12.288c-131.435,0-248.555,136.619-253.483,142.443    c-3.115,3.669-3.371,9.003-0.597,12.992c1.472,2.112,36.736,52.181,97.856,92.779c1.813,1.216,3.84,1.792,5.888,1.792    c3.435,0,6.827-1.664,8.875-4.8c3.264-4.885,1.92-11.52-2.987-14.763c-44.885-29.845-75.605-65.877-87.104-80.533    c24.555-26.667,125.291-128.576,231.552-128.576c19.861,0,41.131,3.755,63.189,11.157c5.589,2.005,11.648-1.088,13.504-6.699    C334.572,126.862,331.585,120.825,325.996,118.947z"
            fill={color || "#778699"}
            data-original="#000000"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M444.865,67.128c-4.16-4.16-10.923-4.16-15.083,0L67.116,429.795c-4.16,4.16-4.16,10.923,0,15.083    c2.091,2.069,4.821,3.115,7.552,3.115c2.731,0,5.461-1.045,7.531-3.115L444.865,82.211    C449.025,78.051,449.025,71.288,444.865,67.128z"
            fill={color || "#778699"}
            data-original="#000000"
          />
        </g>
      </g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
    </g>
  </svg>
);

export const LoaderIcon = ({ height, width, color }) => (
  <svg
    x="0px"
    y="0px"
    height={height || "52"}
    fill={color || "currentColor"}
    width={width || "52"}
    viewBox="0 0 100 100"
  >
    <path d="M73,50c0-12.7-10.3-23-23-23S27,37.3,27,50 M30.9,50c0-10.5,8.5-19.1,19.1-19.1S69.1,39.5,69.1,50">
      <animateTransform
        attributeName="transform"
        attributeType="XML"
        type="rotate"
        dur="1s"
        from="0 50 50"
        to="360 50 50"
        repeatCount="indefinite"
      />
    </path>
  </svg>
);

export const VerifyIcon = ({ height, width, color }) => (
  <svg
    width={width || "17"}
    height={height || "19"}
    viewBox="0 0 17 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.0008 2.485C15.7758 2.32737 15.5156 2.22352 15.2415 2.18189C14.9674 2.14027 14.687 2.16203 14.4232 2.24542C13.7272 2.43563 13.0063 2.52603 12.2834 2.51375C11.2151 2.4574 10.1677 2.2037 9.1971 1.76625C7.99808 1.22731 6.70115 0.924408 5.38109 0.875C2.5314 0.875 1.43689 1.83333 1.23968 1.9675C1.14532 2.05739 1.07051 2.16478 1.0197 2.28331C0.968881 2.40185 0.943093 2.52909 0.943864 2.6575V17.1667C0.943864 17.4208 1.04775 17.6646 1.23267 17.8443C1.41759 18.024 1.6684 18.125 1.92991 18.125C2.19143 18.125 2.44224 18.024 2.62716 17.8443C2.81208 17.6646 2.91596 17.4208 2.91596 17.1667V13.0458C3.70168 12.7535 4.54045 12.6198 5.38109 12.6529C6.44939 12.7093 7.49685 12.963 8.46743 13.4004C9.66644 13.9394 10.9634 14.2423 12.2834 14.2917C13.4721 14.3353 14.6546 14.1055 15.7346 13.6208C16.0257 13.4879 16.2725 13.2782 16.4468 13.0156C16.6212 12.7529 16.7161 12.448 16.7207 12.1354V3.85542C16.7203 3.58802 16.6549 3.32449 16.5298 3.08632C16.4047 2.84816 16.2235 2.64212 16.0008 2.485Z"
      fill="#1A2CCE"
    />
  </svg>
);

export const BrowseIcon = ({ height, width, color }) => (
  <svg
    width={width || "10"}
    height={height || "10"}
    viewBox="0 0 10 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 4.41C7.86739 4.41 7.74021 4.46268 7.64645 4.55645C7.55268 4.65021 7.5 4.77739 7.5 4.91V8.5C7.5 8.63261 7.44732 8.75979 7.35355 8.85355C7.25979 8.94732 7.13261 9 7 9H1.5C1.36739 9 1.24021 8.94732 1.14645 8.85355C1.05268 8.75979 1 8.63261 1 8.5V3C1 2.86739 1.05268 2.74021 1.14645 2.64645C1.24021 2.55268 1.36739 2.5 1.5 2.5H5.09C5.22261 2.5 5.34979 2.44732 5.44355 2.35355C5.53732 2.25979 5.59 2.13261 5.59 2C5.59 1.86739 5.53732 1.74021 5.44355 1.64645C5.34979 1.55268 5.22261 1.5 5.09 1.5H1.5C1.10218 1.5 0.720644 1.65804 0.43934 1.93934C0.158035 2.22064 0 2.60218 0 3V8.5C0 8.89782 0.158035 9.27936 0.43934 9.56066C0.720644 9.84196 1.10218 10 1.5 10H7C7.39782 10 7.77936 9.84196 8.06066 9.56066C8.34196 9.27936 8.5 8.89782 8.5 8.5V4.91C8.5 4.77739 8.44732 4.65021 8.35355 4.55645C8.25979 4.46268 8.13261 4.41 8 4.41ZM9.96 0.31C9.90926 0.187825 9.81217 0.0907374 9.69 0.04C9.62989 0.0143795 9.56534 0.000789994 9.5 0H6.5C6.36739 0 6.24021 0.0526784 6.14645 0.146447C6.05268 0.240215 6 0.367392 6 0.5C6 0.632608 6.05268 0.759785 6.14645 0.853553C6.24021 0.947322 6.36739 1 6.5 1H8.295L3.145 6.145C3.09814 6.19148 3.06094 6.24678 3.03555 6.30771C3.01017 6.36864 2.9971 6.43399 2.9971 6.5C2.9971 6.56601 3.01017 6.63136 3.03555 6.69229C3.06094 6.75322 3.09814 6.80852 3.145 6.855C3.19148 6.90186 3.24678 6.93906 3.30771 6.96445C3.36864 6.98983 3.43399 7.0029 3.5 7.0029C3.56601 7.0029 3.63136 6.98983 3.69229 6.96445C3.75322 6.93906 3.80852 6.90186 3.855 6.855L9 1.705V3.5C9 3.63261 9.05268 3.75979 9.14645 3.85355C9.24021 3.94732 9.36739 4 9.5 4C9.63261 4 9.75979 3.94732 9.85355 3.85355C9.94732 3.75979 10 3.63261 10 3.5V0.5C9.99921 0.434661 9.98562 0.370111 9.96 0.31Z"
      fill="#1A2CCE"
    />
  </svg>
);

export const RefreshIcon = ({ height, width, color }) => (
  <svg
    width={width || "11"}
    height={height || "11"}
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.8417 6.9188C10.6947 6.87299 10.5356 6.88714 10.399 6.95816C10.2624 7.02919 10.1594 7.15133 10.1125 7.29796C9.83692 8.14057 9.29966 8.87327 8.5789 9.38945C7.85813 9.90563 6.99147 10.1784 6.105 10.168C5.00854 10.1804 3.95188 9.75756 3.16673 8.9921C2.38159 8.22664 1.93204 7.18105 1.91667 6.08463C1.93204 4.9882 2.38159 3.94262 3.16673 3.17716C3.95188 2.41169 5.00854 1.98883 6.105 2.0013C7.09525 1.9989 8.05503 2.3436 8.8175 2.97546L7.55167 2.76546C7.4758 2.75298 7.39822 2.75562 7.32338 2.77322C7.24854 2.79083 7.17791 2.82306 7.11557 2.86805C7.05323 2.91305 7.0004 2.96992 6.96011 3.03541C6.91983 3.10089 6.89288 3.17369 6.88083 3.24963C6.86835 3.32549 6.87099 3.40308 6.88859 3.47792C6.9062 3.55276 6.93843 3.62338 6.98342 3.68572C7.02842 3.74807 7.08529 3.8009 7.15078 3.84118C7.21626 3.88147 7.28907 3.90841 7.365 3.92046L9.83833 4.32879H9.9375C10.0051 4.32872 10.0723 4.31687 10.1358 4.2938C10.1572 4.28568 10.177 4.27383 10.1942 4.2588C10.236 4.24324 10.2753 4.22162 10.3108 4.19463L10.3633 4.13046C10.3633 4.10129 10.4158 4.07796 10.4392 4.04296C10.4625 4.00796 10.4392 3.98463 10.4683 3.9613C10.4845 3.92732 10.4981 3.89223 10.5092 3.8563L10.9467 1.52296C10.9612 1.44636 10.9605 1.36764 10.9447 1.29129C10.9288 1.21495 10.8981 1.14248 10.8542 1.07802C10.8103 1.01356 10.7542 0.958375 10.689 0.915613C10.6238 0.872851 10.5508 0.84335 10.4742 0.828795C10.3976 0.81424 10.3188 0.814916 10.2425 0.830785C10.1662 0.846653 10.0937 0.877403 10.0292 0.921279C9.89904 1.00989 9.80939 1.14659 9.78 1.3013L9.6225 2.14713C8.64599 1.30085 7.39719 0.83488 6.105 0.834629C4.69913 0.822184 3.34574 1.36797 2.3418 2.35222C1.33787 3.33647 0.765395 4.67879 0.75 6.08463C0.765395 7.49047 1.33787 8.83279 2.3418 9.81704C3.34574 10.8013 4.69913 11.3471 6.105 11.3346C7.24433 11.3521 8.35918 11.0034 9.28541 10.3397C10.2116 9.67598 10.9003 8.73244 11.25 7.64796C11.2721 7.57328 11.2791 7.49492 11.2704 7.41751C11.2618 7.34009 11.2377 7.2652 11.1997 7.19724C11.1616 7.12927 11.1103 7.06962 11.0488 7.0218C10.9873 6.97398 10.9169 6.93895 10.8417 6.9188Z"
      fill="#5D5D5D"
    />
  </svg>
);
export const WithdrawIcon = ({ height, width, color }) => (
  <svg
    width={width || "12"}
    height={height || "11"}
    viewBox="0 0 12 11"
    fill={color || "none"}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.04 2H1.44C1.3127 2 1.19061 1.94732 1.10059 1.85355C1.01057 1.75979 0.96 1.63261 0.96 1.5C0.96 1.36739 1.01057 1.24021 1.10059 1.14645C1.19061 1.05268 1.3127 1 1.44 1H9.6C9.7273 1 9.84939 0.947321 9.93941 0.853553C10.0294 0.759785 10.08 0.632608 10.08 0.5C10.08 0.367392 10.0294 0.240215 9.93941 0.146447C9.84939 0.0526785 9.7273 0 9.6 0H1.44C1.05822 0.000454899 0.692206 0.158636 0.422249 0.439842C0.152291 0.721048 0.000436703 1.10231 0 1.5V9.5C0.000436703 9.89769 0.152291 10.279 0.422249 10.5602C0.692206 10.8414 1.05822 10.9995 1.44 11H11.04C11.2945 10.9997 11.5385 10.8942 11.7185 10.7068C11.8985 10.5193 11.9997 10.2651 12 10V3C11.9997 2.73488 11.8985 2.4807 11.7185 2.29323C11.5385 2.10576 11.2945 2.0003 11.04 2ZM8.88 7.25C8.7376 7.25 8.59839 7.20601 8.47999 7.1236C8.36159 7.04119 8.2693 6.92406 8.21481 6.78701C8.16031 6.64997 8.14605 6.49917 8.17383 6.35368C8.20162 6.2082 8.27019 6.07456 8.37088 5.96967C8.47158 5.86478 8.59987 5.79335 8.73954 5.76441C8.8792 5.73547 9.02397 5.75033 9.15553 5.80709C9.28709 5.86386 9.39954 5.95999 9.47866 6.08332C9.55777 6.20666 9.6 6.35166 9.6 6.5C9.6 6.69891 9.52414 6.88968 9.38912 7.03033C9.25409 7.17098 9.07096 7.25 8.88 7.25Z"
      fill={color || "currentColor"}
    />
  </svg>
);
export const SwapIcon = ({ height, width, color }) => (
  <svg
    width={width || "12"}
    height={height || "12"}
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.666667 4.00013H9.33333L8.26667 4.80013C8.19663 4.85265 8.13762 4.91846 8.09302 4.9938C8.04841 5.06913 8.01908 5.15251 8.0067 5.23918C7.99432 5.32585 7.99913 5.4141 8.02086 5.49891C8.04259 5.58372 8.0808 5.66342 8.13333 5.73346C8.19543 5.81626 8.27595 5.88346 8.36852 5.92974C8.46109 5.97603 8.56317 6.00013 8.66667 6.00013C8.81091 6.00013 8.95127 5.95334 9.06667 5.86679L11.7333 3.86679C11.8149 3.80458 11.881 3.72439 11.9264 3.63246C11.9719 3.54054 11.9956 3.43936 11.9956 3.33679C11.9956 3.23423 11.9719 3.13305 11.9264 3.04112C11.881 2.9492 11.8149 2.86901 11.7333 2.80679L9.16 0.806793C9.02032 0.698054 8.84316 0.649257 8.66751 0.671136C8.49185 0.693015 8.33207 0.783779 8.22333 0.923459C8.11459 1.06314 8.0658 1.2403 8.08768 1.41596C8.10956 1.59161 8.20032 1.75139 8.34 1.86013L9.38667 2.66679H0.666667C0.489856 2.66679 0.320286 2.73703 0.195262 2.86206C0.0702379 2.98708 0 3.15665 0 3.33346C0 3.51027 0.0702379 3.67984 0.195262 3.80486C0.320286 3.92989 0.489856 4.00013 0.666667 4.00013ZM11.3333 8.66679H2.66667L3.73333 7.86679C3.87478 7.76071 3.96829 7.60277 3.9933 7.42774C4.0183 7.25271 3.97275 7.07491 3.86667 6.93346C3.76058 6.79201 3.60265 6.6985 3.42761 6.67349C3.25258 6.64849 3.07478 6.69404 2.93333 6.80013L0.266667 8.80013C0.185129 8.86234 0.119045 8.94253 0.0735579 9.03446C0.0280706 9.12638 0.00440629 9.22756 0.00440629 9.33013C0.00440629 9.43269 0.0280706 9.53387 0.0735579 9.6258C0.119045 9.71772 0.185129 9.79791 0.266667 9.86013L2.84 11.8601C2.95637 11.9504 3.09937 11.9997 3.24667 12.0001C3.34848 11.9999 3.44888 11.9763 3.54018 11.9313C3.63147 11.8862 3.71123 11.8208 3.77333 11.7401C3.88159 11.6011 3.93044 11.425 3.90921 11.2501C3.88797 11.0752 3.79838 10.9158 3.66 10.8068L2.61333 10.0001H11.3333C11.5101 10.0001 11.6797 9.92989 11.8047 9.80486C11.9298 9.67984 12 9.51027 12 9.33346C12 9.15665 11.9298 8.98708 11.8047 8.86205C11.6797 8.73703 11.5101 8.66679 11.3333 8.66679Z"
      fill="#8D8EA2"
    />
  </svg>
);

export const DOtIcon = ({ height, width, color }) => (
  <svg
    width={width || "44"}
    height={height || "44"}
    viewBox="0 0 44 44"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_d_3507_3916)">
      <rect x="8" y="8" width="28" height="28" rx="5" fill="white" />
      <rect
        x="8.35"
        y="8.35"
        width="27.3"
        height="27.3"
        rx="4.65"
        stroke="#E7E7E7"
        stroke-width="0.7"
      />
    </g>
    <ellipse cx="21.6499" cy="16.0508" rx="1.75" ry="1.75" fill="#AAAAAA" />
    <ellipse cx="21.6499" cy="21.6504" rx="1.75" ry="1.75" fill="#AAAAAA" />
    <circle cx="21.6499" cy="27.25" r="1.75" fill="#AAAAAA" />
    <defs>
      <filter
        id="filter0_d_3507_3916"
        x="0"
        y="0"
        width="44"
        height="44"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="4" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.07 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_3507_3916"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_3507_3916"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);

export const GreaterThanIcon = ({ width, height, color }) => (
  <svg
    width={width || 52}
    height={height || 52}
    fill={color || "currentColor"}
    x="0"
    y="0"
    viewBox="0 0 103.536 103.536"
  >
    <g>
      <g>
        <g>
          <path
            d="M0.65,91.928c1.221,2.701,3.881,4.3,6.665,4.3c1.006,0,2.029-0.209,3.006-0.65l88.917-40.195    c2.688-1.216,4.381-3.925,4.295-6.873c-0.085-2.948-1.934-5.554-4.687-6.609L9.929,7.794C6.17,6.352,1.933,8.23,0.489,12.001    c-1.447,3.769,0.438,7.995,4.207,9.44l72.569,27.834L4.299,82.255C0.62,83.92-1.012,88.249,0.65,91.928z"
            fill={color || "currentColor"}
            data-original="#000000"
          />
        </g>
      </g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
    </g>
  </svg>
);

export const LessThanIcon = ({ width, height, color }) => (
  <svg
    width={width || 52}
    height={height || 52}
    fill={color || "currentColor"}
    x="0"
    y="0"
    viewBox="0 0 103.536 103.536"
  >
    <g>
      <g>
        <g>
          <path
            d="M103.048,12.002c-1.445-3.771-5.679-5.649-9.438-4.207L4.692,41.9c-2.753,1.055-4.603,3.662-4.688,6.609    c-0.087,2.948,1.608,5.656,4.295,6.872l88.917,40.196c0.978,0.44,2,0.65,3.006,0.65c2.784,0,5.442-1.6,6.665-4.302    c1.661-3.678,0.029-8.007-3.648-9.671L26.273,49.277l72.568-27.834C102.61,19.998,104.496,15.771,103.048,12.002z"
            fill={color || "currentColor"}
            data-original="#000000"
          />
        </g>
      </g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
    </g>
  </svg>
);

export const BackIcon = ({ width, height, color }) => (
  <svg
    width={width || 15}
    height={height || 15}
    fill={color || "currentColor"}
    viewBox="0 0 15 15"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.5 0L8.82656 1.32656L3.59063 6.5625H15V8.4375H3.59063L8.82656 13.6734L7.5 15L0 7.5L7.5 0Z"
      fill={color || "#000638"}
    />
  </svg>
);
export const DownArrowIcon = ({ width, height, color }) => (
  <svg
    width={width || 20}
    height={height || 10}
    fill={color || "none"}
    viewBox="0 0 10 6"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9 1L5 4.76477L1 1"
      // stroke="#C2C2C2"
      // stroke-width="2"
      // stroke-miterlimit="10"
      // stroke-linecap="round"
      // stroke-linejoin="round"
      fill={"#C2C2C2"}
    />
  </svg>
);

export const ProgressIcon = ({ width, height, color }) => (
  <svg
    width={width || 19}
    height={height || 20}
    fill={color || "none"}
    viewBox="0 0 19 20"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.5 0.636719C4.25362 0.636719 0 4.85596 0 10.0599C0 15.2639 4.25362 19.4831 9.5 19.4831C14.7464 19.4831 19 15.2639 19 10.0599C19 4.85596 14.7464 0.636719 9.5 0.636719ZM13.9009 7.45323L9.35038 14.3522C9.34919 14.3534 9.34681 14.3545 9.34681 14.3557C9.32306 14.3911 9.31 14.4311 9.28031 14.4641C9.23875 14.5089 9.18531 14.5324 9.13781 14.5666C9.12594 14.5748 9.11406 14.5842 9.101 14.5925C9.02738 14.6384 8.95138 14.669 8.86825 14.6891C8.84094 14.6961 8.816 14.7032 8.7875 14.7079C8.72136 14.7169 8.65434 14.7177 8.588 14.7103C8.54114 14.7073 8.49464 14.7002 8.44906 14.6891C8.40203 14.675 8.35634 14.6569 8.3125 14.6349C8.2745 14.6172 8.23413 14.6125 8.1985 14.5901C8.17238 14.5736 8.15812 14.5477 8.13556 14.5277C8.12606 14.5195 8.11419 14.5171 8.10469 14.5089L5.45538 12.0788C5.29834 11.9293 5.20673 11.7246 5.20023 11.5087C5.19373 11.2929 5.27286 11.0831 5.42062 10.9245C5.56838 10.7659 5.77297 10.6711 5.99042 10.6606C6.20786 10.65 6.42081 10.7245 6.5835 10.868L8.50131 12.6277L12.5091 6.55096C12.6297 6.36789 12.8187 6.23985 13.0345 6.19501C13.2503 6.15017 13.4753 6.19219 13.6598 6.31184C13.8444 6.43149 13.9735 6.61896 14.0187 6.83301C14.0639 7.04706 14.0215 7.27016 13.9009 7.45323Z"
      fill={color || "#00B428"}
    />
  </svg>
);

export const InfoIcon = ({ width, height, color }) => (
  <svg
    width={width || 13}
    height={height || 10}
    fill={color || "none"}
    viewBox="0 0 11 12"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.5 0C2.46262 0 0 2.54179 0 5.67682C0 8.81184 2.46262 11.3536 5.5 11.3536C8.53738 11.3536 11 8.81184 11 5.67682C11 2.54179 8.53738 0 5.5 0ZM4.8125 4.96721C4.8125 4.77902 4.88493 4.59853 5.01386 4.46545C5.1428 4.33237 5.31766 4.25761 5.5 4.25761C5.68234 4.25761 5.8572 4.33237 5.98614 4.46545C6.11507 4.59853 6.1875 4.77902 6.1875 4.96721V8.51522C6.1875 8.70342 6.11507 8.88391 5.98614 9.01699C5.8572 9.15006 5.68234 9.22482 5.5 9.22482C5.31766 9.22482 5.1428 9.15006 5.01386 9.01699C4.88493 8.88391 4.8125 8.70342 4.8125 8.51522V4.96721ZM5.5 3.55936C5.40969 3.55934 5.32028 3.54096 5.23685 3.50527C5.15343 3.46958 5.07763 3.41727 5.01379 3.35135C4.94995 3.28542 4.89932 3.20716 4.86478 3.12104C4.83024 3.03492 4.81248 2.94262 4.8125 2.84941C4.81252 2.7562 4.83033 2.6639 4.86491 2.5778C4.89949 2.49169 4.95016 2.41346 5.01404 2.34757C5.07791 2.28168 5.15373 2.22941 5.23717 2.19377C5.32061 2.15812 5.41004 2.13978 5.50034 2.1398C5.68273 2.13985 5.85762 2.21468 5.98655 2.34782C6.11548 2.48096 6.18789 2.66152 6.18784 2.84976C6.1878 3.03801 6.1153 3.21852 5.98631 3.3516C5.85731 3.48468 5.68238 3.55941 5.5 3.55936Z"
      fill="#6D6D6D"
    />
  </svg>
);

export const LockIcon = ({ width, height, color }) => (
  <svg
    width={width || 13}
    height={height || 10}
    fill={color || "none"}
    viewBox="0 0 21 25"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.2505 7.85315C12.2505 6.89065 11.463 6.10315 10.5005 6.10315C9.53799 6.10315 8.75049 6.89065 8.75049 7.85315V9.60315H12.2505V7.85315Z"
      fill="#1A2CCE"
    />
    <path
      d="M0 4.35313V11.3531C0 18.6156 3.85 20.8031 9.1 23.7781L10.0625 24.3031C10.2375 24.4781 10.325 24.4781 10.5 24.4781C10.675 24.4781 10.7625 24.4781 10.9375 24.3906L11.9 23.8656C17.15 20.8031 21 18.6156 21 11.3531V4.35313C21 4.00313 20.7375 3.65313 20.3875 3.56563L10.7625 0.065625C10.5875 -0.021875 10.325 -0.021875 10.15 0.065625L0.525 3.56563C0.2625 3.65313 0 4.00313 0 4.35313ZM5.25 12.2281C5.25 11.0906 5.95 10.1281 7 9.77813V7.85313C7 5.92813 8.575 4.35313 10.5 4.35313C12.425 4.35313 14 5.92813 14 7.85313V9.77813C15.05 10.1281 15.75 11.0906 15.75 12.2281V14.8531C15.75 17.7406 13.3875 20.1031 10.5 20.1031C7.6125 20.1031 5.25 17.7406 5.25 14.8531V12.2281Z"
      fill="#1A2CCE"
    />
    <path
      d="M10.5 12.2281C9.975 12.2281 9.625 12.5781 9.625 13.1031V14.8531C9.625 15.3781 9.975 15.7281 10.5 15.7281C11.025 15.7281 11.375 15.3781 11.375 14.8531V13.1031C11.375 12.5781 11.025 12.2281 10.5 12.2281Z"
      fill="#1A2CCE"
    />
  </svg>
);

export const PassLockIcon = ({ width, height, color }) => (
  <svg
    width={width || 13}
    height={height || 10}
    fill={color || "none"}
    viewBox="0 0 17 22"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.875 7.33333H13.8125V5.2381C13.8125 2.34667 11.4325 0 8.5 0C5.5675 0 3.1875 2.34667 3.1875 5.2381V7.33333H2.125C0.950938 7.33333 0 8.27095 0 9.42857V19.9048C0 21.0624 0.950938 22 2.125 22H14.875C16.0491 22 17 21.0624 17 19.9048V9.42857C17 8.27095 16.0491 7.33333 14.875 7.33333ZM8.5 16.7619C7.32594 16.7619 6.375 15.8243 6.375 14.6667C6.375 13.509 7.32594 12.5714 8.5 12.5714C9.67406 12.5714 10.625 13.509 10.625 14.6667C10.625 15.8243 9.67406 16.7619 8.5 16.7619ZM11.7938 7.33333H5.20625V5.2381C5.20625 3.44667 6.68313 1.99048 8.5 1.99048C10.3169 1.99048 11.7938 3.44667 11.7938 5.2381V7.33333Z"
      fill="#1A2CCE"
    />
  </svg>
);

export const ClockIcon = ({ width, height, color }) => (
  <svg
    width="13"
    height="14"
    viewBox="0 0 13 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.4375 0.4375C4.4375 0.195875 4.63338 0 4.875 0H8.375C8.61662 0 8.8125 0.195875 8.8125 0.4375C8.8125 0.679125 8.61662 0.875 8.375 0.875H4.875C4.63338 0.875 4.4375 0.679125 4.4375 0.4375ZM10.9555 1.68787C11.1264 1.51701 11.4034 1.51701 11.5743 1.68787L12.8117 2.92531C12.9825 3.09616 12.9825 3.37317 12.8117 3.54402C12.6408 3.71488 12.3638 3.71488 12.193 3.54402L10.9555 2.30659C10.7847 2.13573 10.7847 1.85872 10.9555 1.68787ZM12.75 7.875C12.75 11.2577 10.0077 14 6.625 14C3.24226 14 0.5 11.2577 0.5 7.875C0.5 4.49226 3.24226 1.75 6.625 1.75C10.0077 1.75 12.75 4.49226 12.75 7.875ZM6.1875 3.9375V8.3125C6.1875 8.55412 6.38338 8.75 6.625 8.75C6.86662 8.75 7.0625 8.55412 7.0625 8.3125V3.9375C7.0625 3.69588 6.86662 3.5 6.625 3.5C6.38338 3.5 6.1875 3.69588 6.1875 3.9375Z"
      fill={color || "#545A63"}
    />
  </svg>
);

export const BankIcon = ({ width, height, color }) => (
  <svg
    width="33"
    height="33"
    viewBox="0 0 33 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="16.5" cy="16.5" r="16.5" fill="#D3E9FF" />
    <path
      d="M11.3684 15.4286V20.4286H13.4211V15.4286H11.3684ZM15.4737 15.4286V20.4286H17.5263V15.4286H15.4737ZM10 24H23V21.8571H10V24ZM19.5789 15.4286V20.4286H21.6316V15.4286H19.5789ZM16.5 9L10 12.5714V14H23V12.5714L16.5 9Z"
      fill={color || "#1A2CCE"}
    />
  </svg>
);

export const WalletIcon = ({ width, height, color }) => (
  <svg
    width="33"
    height="33"
    viewBox="0 0 33 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="16.4994" cy="16.5" r="16.5" fill="#D1DDF0" />
    <path
      d="M20.0827 17.8333C20.4299 17.8333 20.7389 17.6979 21.0098 17.4271C21.2806 17.1562 21.416 16.8403 21.416 16.4792C21.416 16.1319 21.2806 15.8264 21.0098 15.5625C20.7389 15.2986 20.4299 15.1667 20.0827 15.1667C19.7355 15.1667 19.4264 15.2986 19.1556 15.5625C18.8848 15.8264 18.7494 16.1319 18.7494 16.4792C18.7494 16.8403 18.8848 17.1562 19.1556 17.4271C19.4264 17.6979 19.7355 17.8333 20.0827 17.8333ZM17.7077 20.3958C17.2355 20.3958 16.8605 20.2569 16.5827 19.9792C16.3049 19.7014 16.166 19.3333 16.166 18.875V14.1458C16.166 13.6736 16.3049 13.3021 16.5827 13.0312C16.8605 12.7604 17.2355 12.625 17.7077 12.625H23.3119C23.7841 12.625 24.1591 12.7604 24.4369 13.0312C24.7146 13.3021 24.8535 13.6736 24.8535 14.1458V18.875C24.8535 19.3333 24.7146 19.7014 24.4369 19.9792C24.1591 20.2569 23.7841 20.3958 23.3119 20.3958H17.7077ZM10.2494 24C9.92991 24 9.64172 23.875 9.38478 23.625C9.12783 23.375 8.99936 23.0833 8.99936 22.75V10.25C8.99936 9.93056 9.12783 9.64236 9.38478 9.38542C9.64172 9.12847 9.92991 9 10.2494 9H22.7494C23.0827 9 23.3744 9.12847 23.6244 9.38542C23.8744 9.64236 23.9994 9.93056 23.9994 10.25V11.375H17.7077C16.9021 11.375 16.2355 11.6389 15.7077 12.1667C15.1799 12.6944 14.916 13.3542 14.916 14.1458V18.875C14.916 19.6667 15.1799 20.3264 15.7077 20.8542C16.2355 21.3819 16.9021 21.6458 17.7077 21.6458H23.9994V22.75C23.9994 23.0833 23.8744 23.375 23.6244 23.625C23.3744 23.875 23.0827 24 22.7494 24H10.2494Z"
      fill={color || "#212121"}
    />
  </svg>
);

export const UserIcon = ({ width, height, color }) => (
  <svg
    width="33"
    height="33"
    viewBox="0 0 33 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="16.4994" cy="16.5" r="16.5" fill="#D1DDF0" />
    <path
      d="M16.7288 16.2464C15.666 16.2464 14.7965 15.9082 14.1201 15.2319C13.4438 14.5556 13.1056 13.686 13.1056 12.6232C13.1056 11.5604 13.4438 10.6908 14.1201 10.0145C14.7965 9.33816 15.666 9 16.7288 9C17.7916 9 18.6612 9.33816 19.3375 10.0145C20.0139 10.6908 20.352 11.5604 20.352 12.6232C20.352 13.686 20.0139 14.5556 19.3375 15.2319C18.6612 15.9082 17.7916 16.2464 16.7288 16.2464ZM8.99936 24V21.7295C8.99936 21.1176 9.15234 20.5942 9.4583 20.1594C9.76425 19.7246 10.1588 19.3945 10.6419 19.1691C11.7208 18.686 12.7554 18.3237 13.7457 18.0821C14.7361 17.8406 15.7304 17.7198 16.7288 17.7198C17.7272 17.7198 18.7176 17.8446 19.6998 18.0942C20.6821 18.3438 21.7127 18.7021 22.7916 19.1691C23.2908 19.3945 23.6934 19.7246 23.9994 20.1594C24.3053 20.5942 24.4583 21.1176 24.4583 21.7295V24H8.99936Z"
      fill={color || "#212121"}
    />
  </svg>
);

export const PendingClockIcon = ({ width, height, color }) => (
  <svg
    width="59"
    height="58"
    viewBox="0 0 59 58"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="2" y="1.5" width="55" height="55" rx="27.5" fill="#F9EFDC" />
    <path
      d="M30.325 28.7V24.425C30.325 24.2083 30.2542 24.0292 30.1125 23.8875C29.9708 23.7458 29.7917 23.675 29.575 23.675C29.3583 23.675 29.1792 23.7458 29.0375 23.8875C28.8958 24.0292 28.825 24.2083 28.825 24.425V29C28.825 29.1 28.8417 29.1917 28.875 29.275C28.9083 29.3583 28.9583 29.4417 29.025 29.525L32.625 33.25C32.775 33.4167 32.9625 33.4958 33.1875 33.4875C33.4125 33.4792 33.6 33.4 33.75 33.25C33.9 33.1 33.975 32.9167 33.975 32.7C33.975 32.4833 33.9 32.3 33.75 32.15L30.325 28.7ZM29.5 39C28.1333 39 26.8417 38.7375 25.625 38.2125C24.4083 37.6875 23.3458 36.9708 22.4375 36.0625C21.5292 35.1542 20.8125 34.0917 20.2875 32.875C19.7625 31.6583 19.5 30.3667 19.5 29C19.5 27.6333 19.7625 26.3417 20.2875 25.125C20.8125 23.9083 21.5292 22.8458 22.4375 21.9375C23.3458 21.0292 24.4083 20.3125 25.625 19.7875C26.8417 19.2625 28.1333 19 29.5 19C30.8667 19 32.1583 19.2625 33.375 19.7875C34.5917 20.3125 35.6542 21.0292 36.5625 21.9375C37.4708 22.8458 38.1875 23.9083 38.7125 25.125C39.2375 26.3417 39.5 27.6333 39.5 29C39.5 30.3667 39.2375 31.6583 38.7125 32.875C38.1875 34.0917 37.4708 35.1542 36.5625 36.0625C35.6542 36.9708 34.5917 37.6875 33.375 38.2125C32.1583 38.7375 30.8667 39 29.5 39Z"
      fill={color || "#D39522"}
    />
    <rect
      x="2"
      y="1.5"
      width="55"
      height="55"
      rx="27.5"
      stroke="#F1D7A7"
      stroke-width="3"
    />
  </svg>
);
